
export default {
  data() {
    return {
      pageData: null,
      inView: false,
      page: null,
      pages: null,
      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "link",
          label: "Poveznica",
          type: "link",
        },
      ],
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    async getPages() {
      this.pages = await this.$getCustomPost([
        this.pageData.terms.categories[0].id,
      ]);
    },
    getPageData() {
      this.pageData = this.$parent.$parent.pageData;
      this.page = this.pageData.slug;
      this.getPages();
    },
  },
};
